import { combineReducers } from 'redux'
import request from 'utils/request'
import { getPasswordError, addErrorClass } from 'utils/misc'
import { authActions } from 'store/user'
import { actions as loginActions } from '../../../../Login/modules/Login'
import { navigateTo } from 'navigation'
import { logSentryEvent } from '../../../../../utils/sentry'

const ERROR_MESSAGE_MAP_STRING_KEY = {
  'Passwords do not match': 'pw_mismatch',
  'Wrong Password': 'linkt_wrong_password'
}

const SHOW_CHANGE_PASSWORD = 'SHOW_CHANGE_PASSWORD'
const UPDATE_NEW_PASSWORD = 'UPDATE_NEW_PASSWORD'
const RESET_PW_STATE = 'RESET_PW_STATE'
const SET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR'
const CLEAR_PASSWORD_ERROR = 'CLEAR_PASSWORD_ERROR'

function resetPasswordState() {
  return {
    type: RESET_PW_STATE
  }
}

function updateNewPassword(field, value) {
  return {
    type: UPDATE_NEW_PASSWORD,
    field,
    value
  }
}

function showChangePassword() {
  return {
    type: SHOW_CHANGE_PASSWORD
  }
}

const setPasswordError = (response, payload, strings) => {
  const errorMessage = strings[ERROR_MESSAGE_MAP_STRING_KEY[payload]] || payload
  return { type: SET_PASSWORD_ERROR, errorMessage }
}

const clearPasswordError = () => {
  return { type: CLEAR_PASSWORD_ERROR }
}

const generateBlankPWState = () => {
  return {
    oldPassword: '',
    newPassword: '',
    newPasswordConfirmation: ''
  }
}

function setNewPassword(
  { changePassword },
  successMessage,
  redirectPath = '/profile'
) {
  return (dispatch, getState) => {
    const { strings, login, user } = getState()

    const passwordError = getPasswordError(
      changePassword.newPassword,
      changePassword.newPasswordConfirmation,
      dispatch,
      strings
    )
    if (!passwordError) {
      logSentryEvent({
        message: 'Change password: submit_started',
        tags: {
          flow: 'change-password',
          'password.action': 'submit_started'
        }
      })
      const success = () => {
        logSentryEvent({
          message: 'Change password: submit_success',
          tags: {
            flow: 'change-password',
            'password.action': 'submit_success'
          }
        })
        dispatch(clearPasswordError())
        dispatch(loginActions.clearTempPassword())
        dispatch(authActions.changedPassword())
        navigateTo(redirectPath)
      }
      const resolvedOldPassword =
        changePassword.oldPassword ||
        (user?.is_temporary_password ? login?.tempPassword || '' : '')
      const reqObject = {
        old_password: resolvedOldPassword,
        new_password: changePassword.newPassword
      }

      const changePasswordRequest = request({
        method: 'POST',
        url: '/control/change_password',
        body: JSON.stringify(Object.assign({}, reqObject)),
        successMessage,
        success,
        authRequired: false,
        fail: (res, payload) => setPasswordError(res, payload, strings)
      })
      return dispatch(changePasswordRequest).catch(error => {
        logSentryEvent({
          message: 'Change password: submit_failed',
          level: 'error',
          tags: {
            flow: 'change-password',
            'password.action': 'submit_failed'
          },
          error
        })
        throw error
      })
    }
    logSentryEvent({
      message: 'Change password: validation_failed',
      level: 'error',
      tags: {
        flow: 'change-password',
        'password.action': 'validation_failed'
      }
    })
    addErrorClass(['user-password', 'user-password-confirmation'])
  }
}

const changePassword = (state = generateBlankPWState(), action) => {
  switch (action.type) {
    case RESET_PW_STATE: {
      return generateBlankPWState()
    }
    case UPDATE_NEW_PASSWORD: {
      return Object.assign({}, state, { [action.field]: action.value })
    }
    default: {
      return state
    }
  }
}

const passwordError = (state = null, action) => {
  switch (action.type) {
    case SET_PASSWORD_ERROR: {
      return action.errorMessage
    }
    case CLEAR_PASSWORD_ERROR:
      return null
    default:
      return state
  }
}

export const actions = {
  updateNewPassword,
  resetPasswordState,
  showChangePassword,
  setNewPassword,
  setPasswordError,
  clearPasswordError
}

export default combineReducers({ changePassword, passwordError })
